import { topicItems } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          热门话题
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          加入讨论，分享你的观影感受
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.label}
              className="inline-flex items-center gap-2.5 px-4 py-2.5 bg-background-100 border border-background-200/40 rounded-full hover:border-primary-500/30 hover:bg-background-200/50 transition-all duration-200 cursor-pointer group whitespace-nowrap"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-sm`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-200">{item.label}</span>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}